import React from 'react';
import Tag, { TagType } from 'components/cards/new-layout/components/Tag';
import { ViewedLabelWrapper } from 'ds/components/ListingCard';
import ViewedIcon from 'assets/svg/viewed.svg';
import { useLocale } from 'locale';
import { connect, useSelector } from 'react-redux';
import { isInLastViewedSelector } from 'store/state/selectors/poi';
import { State } from 'store/state';
import { marketplaceSelector } from 'store/state/selectors/router';
import { MarketplaceType } from 'utils/entities';

interface ProjectTagProps {
  id: string;
  isInLastViewed?: boolean;
  hasDiscount: boolean;
  isPromoted: boolean;
  inSearchArea: boolean;
}

const BaseProjectTag: React.FC<ProjectTagProps> = ({ hasDiscount, isPromoted, inSearchArea, isInLastViewed }) => {
  const marketplace = useSelector(marketplaceSelector);
  const isRecentlyViewedV2 = marketplace === MarketplaceType.Residential;
  const { t } = useLocale();

  if (isRecentlyViewedV2 && isInLastViewed) {
    return (
      <ViewedLabelWrapper>
        <ViewedIcon />
        {t('unitPage.dateLabel.viewed')}
      </ViewedLabelWrapper>
    );
  }

  if (hasDiscount) return <Tag type={TagType.Discount} />;
  if (inSearchArea) return <Tag type={TagType.InSearchArea} />;
  if (isPromoted) return <Tag type={TagType.Project} />;

  return null;
};

const mapStateToProps = (state: State, props: ProjectTagProps) => ({
  isInLastViewed: isInLastViewedSelector(state, props.id),
});

const ProjectTag = connect(mapStateToProps)(BaseProjectTag);

export default ProjectTag;
